import { createEffect, onCleanup } from 'solid-js'

export interface TradingViewWidgetProps {
  exchange?: string | null,
  symbol?: string | null
  id: string
  // Compact embeds (cards/dialogs) hide these by default; the full side-panel view shows them.
  hideTopToolbar?: boolean
  hideSideToolbar?: boolean
}

export function TradingViewWidget(props: TradingViewWidgetProps) {
  let containerRef: HTMLDivElement | undefined

  const loadWidget = () => {
    // Don't attempt to load if the container isn't ready or props are missing
    if (!containerRef || !props.exchange || !props.symbol) return

    // Remove existing script if it exists (prevents duplicate loading)
    const existingScript = document.querySelector('#tradingview-script')
    if (existingScript) existingScript.remove()

    // Clean up the inner container to prevent overlapping iframes on prop changes
    containerRef.innerHTML = `<div class="tradingview-widget-container__widget" style="height:calc(100%);width:100%"></div>`

    // Create a new script element
    const script = document.createElement('script')
    script.id = props.id
    script.src =
      'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js'
    script.type = 'text/javascript'
    script.async = true

    // Widget configuration
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol: `${props.exchange}:${props.symbol}`,
      interval: 'D',
      timezone: 'Etc/UTC',
      theme: 'dark',
      style: '1',
      locale: 'en',
      hide_top_toolbar: props.hideTopToolbar ?? true,
      hide_side_toolbar: props.hideSideToolbar ?? true,
      hide_legend: true,
      allow_symbol_change: false,
      save_image: false,
      support_host: 'https://www.tradingview.com',
    })

    // Append script inside the container
    containerRef.appendChild(script)
  }

  // createEffect automatically runs on mount and tracks props.exchange/props.symbol
  createEffect(() => {
    loadWidget()
  })

  // Cleanup to prevent memory leaks when the component unmounts
  onCleanup(() => {
    const existingScript = document.querySelector('#tradingview-script')
    if (existingScript) existingScript.remove()
  })

  return (
    <div
      class="tradingview-widget-container"
      style="height:100%; width:100%"
      ref={containerRef}
    />
  )
}
